import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.775}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15040 24504"
    {...props}
  >
    <path
      d="m10270 3749-37 37c-23 11-46 24-66 41-37 31-65 67-83 108l-674 674c-273-545-636-1056-1090-1510s-964-817-1510-1089l860-860c347-347 809-538 1300-538s953 191 1300 538 538 809 538 1299c0 491-191 953-538 1300zm-2173 6925L5946 8522l-11-11c-2-1-4-3-6-5L746 3322c2042-1817 5183-1747 7141 210 1957 1958 2028 5099 210 7142zM2903 8546c-662-646-730-1673-199-2399l2569 2568c-712 521-1719 468-2370-169zm9993 13814c845 0 1532 687 1532 1531H1563c0-844 687-1531 1531-1531h9802zm-2848-6612c-1270 1867-2282 3355-2355 5999H3094c-1182 0-2144 962-2144 2144v307c0 169 137 306 307 306h13477c169 0 306-137 306-306v-307c0-1182-961-2144-2144-2144H8306c71-2452 992-3807 2249-5654 208-306 425-625 649-963 1022-1551 1563-3356 1563-5221 0-2102-703-4153-1985-5810 413-452 638-1034 638-1650 0-654-255-1270-717-1732-956-956-2510-956-3466 0L6205 1749C4143 999 1740 1449 90 3099c-120 120-120 314 0 433l2177 2178c-770 970-697 2390 208 3274 891 871 2282 924 3234 169l2178 2177c120 119 313 119 433 0 1651-1651 2101-4054 1350-6115l677-677c1168 1538 1807 3432 1807 5371 0 1745-506 3434-1462 4884-221 336-436 652-644 955z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
